<template>
	<div>
		<v-card class="sidebar">
			<v-list class="sidebar-list pa-0">
				<div v-if="isSettingsPage" class="sidebar__profile">
					<Avatar 
						:avatar="profile.user_logo"
						:size="130"
						borderRadius="square"
					/>
					<p class="sidebar__profile-username mt-5 mb-0">
						{{ profile.visible_username }}
					</p>
					<p v-if="profile.third_profile_row" class="sidebar__profile-text mt-2 mb-0">
						{{ profile.third_profile_row }}
					</p>
					<p v-if="profile.second_profile_row" class="sidebar__profile-text mt-1 mb-0">
						{{ profile.second_profile_row }}
					</p>
					<v-btn class="sidebar__profile-btn elevation-0" @click="toMyProfile">
						My Profile
					</v-btn>
				</div>
				<a v-else-if="bannerUrl" class="sidebar-link" :href="bannerUrl" target='_blank'>
					<img
						style="width: 100%; border-radius: 10px;"
						:src="imageSource"
						alt="add banner"
						loading="lazy"
					/>
				</a>
				<img
					v-else
					class="sidebar-link"
					style="width: 100%; border-radius: 10px;"
					:src="imageSource"
					alt="add banner"
					loading="lazy"
				/>
			</v-list>
		</v-card>
	</div>
</template>

<script>
import { mapGetters } from 'vuex'
import Avatar from '@/components/Avatar'

export default {
	name: 'AdBanner',
	components: {
		Avatar
	},
	methods: {
		toMyProfile() {

		}
	},
	computed: {
		...mapGetters('settings', ['web']),
		...mapGetters('auth', ['profile']),

		imageSource() {
			if (!this.web) {
				return ''
			}
			return this.web.banner_image
		},
		bannerUrl() {
			if (!this.web) {
				return ''
			}
			return this.web.banner_url
		},
		isSettingsPage() {
			return this.$route.name === 'settings'
		}
	},
}
</script>

<style scoped lang="scss">
.sidebar {
	max-width: 250px;
	width: 100%;
	border-radius: 10px !important;
	box-shadow: none !important;

	&-link {
		display: flex;
	}

	&__profile {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 16px;
		font-family: Montserrat, sans-serif;
		background-color: #fff;
		border-radius: 10px;

		&-username {
			font-size: 15px;
			font-weight: 700;
			line-height: 20px;
			color: #4a4a4a;
		}

		&-text {
			font-size: 13px;
			line-height: 19.37px;
			color: #4a4a4a;
		}

		&-btn {
			width: 100%;
			margin-top: 30px;
			background-color: var(--button-secondary-background-color) !important;
			color: var(--button-secondary-color) !important;
			text-transform: capitalize;
			font-size: 18px;
			font-weight: 700;
			line-height: 21.94px;
			height: 42px !important;
			border-radius: 8px;
		}
	}
}
</style>
